import { IRadioOption } from '@/pages/benchmark/components/TabsAndRadio';
import React, { useMemo } from 'react';
import { useParams } from 'umi';

export interface IRadioServiceOption extends IRadioOption {
  key: string;
}

export default function MetricDetailTabService(props: any) {
  const { style, className, tabsOptions: propsOptions, logConfig: propsLogConfig, radioOptions: propsRadioOptions, children, data, ...resetProps } = props || {};
  const { metricConfig: allMetricConfig } = data || {};
  const { metric } = useParams<{ metric: string; }>();

  const { tabsOptions, logConfig } = useMemo(() => {
    // 处理指标详情页面根据后端配置筛选器显示隐藏
    const metricConfig = allMetricConfig?.[metric] || {};
    const { by_genre: genre, by_country: country, by_platform: platform, by_region: region, by_stage: stage } = metricConfig || {};
    const optionsMap: any = { genre, country, platform, region, stage };
    const { options } = propsOptions || {};
    const showOptions = options?.filter((v: { value: string | number; }) => optionsMap?.[v?.value] === "true");
    const tabsOptions = { ...propsOptions, options: showOptions };
    // 打点信息修改
    // 配置的打点信息 筛选器信息 
    const extInfo = { ...(propsLogConfig?.extInfo || {}), filters: resetProps.filterVal || {}, metric: metricConfig };
    const logConfig = { ...(propsLogConfig || {}), extInfo };
    return { tabsOptions, logConfig };
  }, [allMetricConfig, metric, propsLogConfig, propsOptions, resetProps.filterVal]);

  // 根据指标配置，过滤radio选项
  const radioOptions = useMemo(() => {
    const valueType = allMetricConfig[metric]?.value_type;
    const valueTypeArray = valueType?.trim()?.split(',')?.map((item: string) => item?.trim()) || [];
    const { options, defaultValue = 'median' } = propsRadioOptions || {};
    const newRadioOptions = valueTypeArray.length > 0 ? options?.filter((option: IRadioServiceOption) => valueTypeArray.includes(option.key)) : options;
    return {
      options: newRadioOptions,
      // 单选项大于1个，则取默认值
      defaultValue: newRadioOptions?.length > 1 ? defaultValue : newRadioOptions?.[0]?.value
    };
  }, [allMetricConfig, metric]);

  return (
    <div className={className} style={style}>
      {React.Children.map(children, (child: any) => React.cloneElement(
        child,
        {
          logConfig,
          tabsOptions,
          data,
          radioOptions,
          ...resetProps
        }))}
    </div>
  );
}
